"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responseError = exports.response = exports.requestError = exports.requestConfig = void 0;

var _myHistory = require("../myHistory");

var _queryString = _interopRequireDefault(require("query-string"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGOUT_URL = _queryString.default.stringifyUrl({
  url: process.env.REACT_APP_TOKEN_LOGOUT
});

var requestConfig = function requestConfig(config) {
  var token = localStorage.getItem('TOKEN');

  if (token && token !== null && token !== 'null') {
    config.headers['Authorization'] = 'Bearer ' + token;
  }

  return config;
};

exports.requestConfig = requestConfig;

var requestError = function requestError(error) {
  Promise.reject(error);
};

exports.requestError = requestError;

var response = function response(_response) {
  return _response;
};

exports.response = response;

var responseError = function responseError(error) {
  if (error === undefined || error.response === undefined) {
    return Promise.reject(error);
  }

  if (error.response.status === 401) {
    var token = localStorage.getItem('TOKEN');

    if (token && token !== null && token !== 'null') {
      localStorage.setItem('TOKEN', null);
      window.location.href = LOGOUT_URL;
    } else {
      _myHistory.myHistory.push('/login');
    }

    return Promise.reject(error);
  } else if (error.response.status === 400) {
    if (error.response.message === 'invalid_token') {
      localStorage.setItem('TOKEN', null);
      window.location.href = LOGOUT_URL;

      _myHistory.myHistory.push('/login');
    }
  } else if (error.response.status === 500) {
    localStorage.setItem('TOKEN', null);
    window.location.href = LOGOUT_URL;

    _myHistory.myHistory.push('/login');
  }

  return Promise.reject(error);
};

exports.responseError = responseError;